export default __webpack_public_path__ + "static/thank-you-failed-7a90cd34eeaeee7569e6c7179b77cf2a.png";